import type { Options } from "highcharts";

import { tooltipConfig } from "./chartTooltip";

interface IChartSize {
    height: number;
    width: number;
}

const createGraphConfig = (size: IChartSize): Options => ({
    chart: {
        ...size,
        margin: 0,
        spacing: [0, 0, 0, 0],
        plotBorderWidth: 0,
    },
    // @ts-ignore FIXME: strict migration - Type 'null' is not assignable to type 'string | undefined' — Highcharts requires null (not undefined) to suppress the default chart title text
    title: { text: null },
    legend: { enabled: false },
    credits: { enabled: false },
    tooltip: tooltipConfig,
    plotOptions: {
        series: {
            states: {
                hover: {
                    halo: {
                        size: 10,
                    },
                },
            },
        },
        pie: {
            size: "100%",
            center: ["50%", "50%"],
            borderWidth: 0,
            borderRadius: 0,
            dataLabels: {
                enabled: false,
                connectorWidth: 0,
            },
        },
    },
});

export const smallGraphConfig = createGraphConfig({ height: 100, width: 100 });
export const largeGraphConfig = createGraphConfig({ height: 180, width: 180 });
